import ImageLibrary, { Image } from '../Resource/ImageLibrary';

export type PatternDesignImage = Image & {
	recolorable: boolean,
	categoryId: number,
}

export default class PatternDesignServiceLibrary extends ImageLibrary {
	protected crossOrigin:string = 'anonymous';

	public retrieve = (image:PatternDesignImage, full:boolean = false):Promise<PatternDesignImage> => {
		return this.retrieveImage(image, full) as Promise<PatternDesignImage>;
	}

	public retrieveAll = (images:PatternDesignImage[]):Promise<PatternDesignImage[]> => Promise.all(images.map(i => this.retrieve(i)));
}